export default __webpack_public_path__ + "453a753446d5189c4bf05ff502ba4544.svg";